import StateObserver from 'src/StateObserver';
import PopupCheats, { Item } from 'src/game/cheats/PopupCheats';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { CheatData } from 'src/game/cheats/cheats.sequences';
import { duration } from 'src/replicant/utils/duration';
import { getTournament } from './match2-tournament.utils';
import { withLoading } from 'src/lib/utils';
import { Feature } from 'src/replicant/analytics';
import { refreshTournament } from './match2-tournament.sequence';
import features from 'src/replicant/ruleset/features';
import { match2TournamentUnlockLevel } from 'src/replicant/match2/tournament/match2-tournament.ruleset';
import * as match2TournamentGetters from 'src/replicant/match2/tournament/match2-tournament.getters';

const MATCH2_TOURNAMENTS = 'match2 Tournaments';

const list = () => {
  const user = StateObserver.getState().user;
  if (!match2TournamentGetters.isTournamentFeatureUnlocked(user)) return {};

  const cheats: Record<string, CheatData[]> = {};

  cheats[MATCH2_TOURNAMENTS] = [
    {
      text: 'Reset Tournaments',
      color: 'secondary',
      cheat: async () => {
        StateObserver.invoke.cheat_resetMatch2Tournaments();
      },
    },
    {
      text: 'Increase Tournament Score',
      color: 'secondary',
      cheat: async () => {
        const score = 3;
        await StateObserver.invoke.cheat_increaseMatch2TournamentScore({
          score,
        });
        await refreshTournament();
      },
    },
    {
      text: 'Travel 1 Day Ahead',
      color: 'secondary',
      cheat: async () => {
        const day = duration({ days: 1 });
        const currentOffset = await StateObserver.invoke.cheat_getClockOffset();
        const offset = currentOffset + day;
        await StateObserver.invoke.cheat_setClockOffset({ offset });

        await getTournament()?.invalidate();
      },
    },
    {
      text: 'Reset Time',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_setClockOffset({ offset: 0 });

        await getTournament()?.invalidate();
      },
    },

    {
      text: 'Finish Tounament',
      color: 'secondary',
      cheat: async () => {
        const position = await withLoading(
          async () => (await getTournament()?.get())?.currentRank,
          {
            feature: Feature.CHEATS._,
            subFeature: Feature.CHEATS._,
          },
        );
        if (position) {
          StateObserver.invoke.cheat_finishCurrentMatch2Tournament({
            position,
          });
        }
      },
    },
  ];

  return cheats;
};

const ui = (args: {
  key: string;
  popup: PopupCheats;
  item: Item;
  title: LangBitmapFontTextView;
  setting: CheatData[];
  parent: Item | null;
}) => {
  const user = StateObserver.getState().user;
  if (!match2TournamentGetters.isTournamentFeatureUnlocked(user)) return;

  switch (args.key) {
    case MATCH2_TOURNAMENTS:
      args.title.updateOpts({
        width: args.item.style.width - 40,
        height: 20,
        y: 8,
        align: 'center',
      });
      args.popup.createVerticalButtons(args.item, args.setting);
      break;
  }
};

export const match2TournamentsCheats = {
  list,
  ui,
};
